import React, { useEffect, useState } from "react";
import Pagination from "../../../utils/Paginate";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");
const ListContentDescriptors = () => {
  const [currentPage, setCurrentPage] = useState(1);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentDescriptors: [],
    filteredContentDescriptors: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptors `,
        apiHeader(token)
      )
      .then((res) => {
        const contentDescriptors = res.data;
        console.log(contentDescriptors);
        setState({
          ...state,
          contentDescriptors: contentDescriptors,
          filteredContentDescriptors: contentDescriptors,
        });
        console.log(res.data[0]);
        setLoading(false);
      }).
      catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-descriptors/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({
          ...state,
          contentDescriptors: [],
          filteredContentDescriptors: [],
        });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({
      ...state,
      contentDescriptors: [],
      filteredContentDescriptors: [],
    });
    handleOnLoad();
    // this.props.history.push("/list-content-descriptors");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-descriptors?filter[limit]=50`;
    URL += `&filter[where][or][0][contentDescriptorName][regexp]=/(${search})/i&filter[where][or][1][contentDescriptorDescription][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentDescriptors = res.data;
      console.log(contentDescriptors);
      setState({ ...state, filteredContentDescriptors: contentDescriptors });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentDescriptors.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Descriptors</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        	<Link to="/breeze/create-content-descriptor">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-descriptor-types">
          <Button
            variant="contained"
            color="warning"
          >
            Types
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Type</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentDescriptorId,
                    contentDescriptorName,
                    contentDescriptorDescription,
                    contentDescriptorTypeId,
                  }) => {
                    // value =(contentDescriptorDescription.contentDescriptorId)
                    return (
                      <tr>
                        <td value={contentDescriptorId}>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptors",
                              search: `?id=${contentDescriptorId}`,
                            }}
                            id={contentDescriptorId}
                          >
                            {contentDescriptorId}
                          </Link>
                        </td>
                        <td value={contentDescriptorName}>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptors",
                              search: `?id=${contentDescriptorId}`,
                            }}
                            id={contentDescriptorId}
                          >
                            {contentDescriptorName}
                          </Link>
                        </td>
                        <td value={contentDescriptorDescription}>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptors",
                              search: `?id=${contentDescriptorId}`,
                            }}
                            id={contentDescriptorId}
                          >
                            {contentDescriptorDescription}
                          </Link>
                        </td>
                        <td value={contentDescriptorTypeId}>
                          {" "}
                          <Link
                            to={{
                              pathname: "/manage-content-descriptors",
                              search: `?id=${contentDescriptorId}`,
                            }}
                            id={contentDescriptorId}
                          >
                            {contentDescriptorTypeId}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptors",
                              search: `?id=${contentDescriptorId}`,
                            }}
                            id={contentDescriptorId}
                            className="btn btn-success"
                          >
                            Edit
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentDescriptorId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentDescriptors.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />

    </form>
  );
};

export default ListContentDescriptors;
